import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const HCFCSPConfig = {
  cspConfiguration: {
    partner: 'hcf',
    partnerTitle: 'HCF Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'hcf-sit-petportal-auth.petsure.com.au',
        appClientId: 'N7KGSy0EjfnB6NEjGZI4xVl6WduAd1vM',
        cspMfaUrl: 'https://hcf-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'hcf-uat-petportal-auth.petsure.com.au',
        appClientId: 'vATK9cuRuJNSsGhZ5I54ily3RWxMqmiT',
        cspMfaUrl: 'https://hcf-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'hcf-preprod-petportal-auth.petsure.com.au',
        appClientId: '4SWHnPMkBucyWNMpX0GlFkljh0kyPljr',
        cspMfaUrl: 'https://hcf-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'hcf-petportal-auth.petsure.com.au',
        appClientId: 'QijivJaVjDlNPWEyAEu0dtt9JemvcqLs',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://hcf-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: ''
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'hcf.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'hcf.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'hcf.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'hcf.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-hcf.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-hcf.png'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/hcf-favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/hcf-favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/hcf-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/hcf-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/hcf-footer.png',
        imageTitle: 'HCF Pet Insurance',
        imageTitleDescription: 'HCF Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/hcf-footer.png',
        imageTitle: 'HCF Pet Insurance',
        imageTitleDescription: 'HCF Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'HCF - Pet Portal Login',
      description:
        'Access your HCF Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
